"use client";

import { MemoryBank } from "@/components/memory-bank";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { MemoryItem } from "@/db/schema/memory";
import { useEffect, useState } from "react";

interface MemoryBankDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    patientId: string;
}

export function MemoryBankDialog({
    open,
    onOpenChange,
    patientId,
}: MemoryBankDialogProps) {
    const [memories, setMemories] = useState<MemoryItem[]>([]);
    const [loading, setLoading] = useState(true);

    // Fetch memories when dialog opens
    useEffect(() => {
        if (open && patientId) {
            const fetchMemories = async () => {
                setLoading(true);
                try {
                    const response = await fetch("/api/memories");
                    if (!response.ok)
                        throw new Error("Failed to fetch memories");
                    const data = await response.json();
                    setMemories(data);
                } catch (error) {
                    console.error("Failed to fetch memories", error);
                } finally {
                    setLoading(false);
                }
            };

            fetchMemories();
        }
    }, [open, patientId]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-6xl max-h-[80vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>Memory Bank</DialogTitle>
                </DialogHeader>
                {loading ? (
                    <div className="flex items-center justify-center p-8">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                    </div>
                ) : (
                    <MemoryBank memories={memories} patientId={patientId} />
                )}
            </DialogContent>
        </Dialog>
    );
}
